export class fileUtil {
    static dataURItoBlob(dataURI: string) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer // #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], { type: mimeString });
        return blob;

    }

    static async readFileAsDataURL(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                if (reader.result) {
                    resolve(reader.result as string);
                } else {
                    reject('FileReader  has no result');
                }
            });
            reader.readAsDataURL(file);
        });
    }

    static getFileNameWithoutExtension(fileName: string | File) {
        const lFileName: string = typeof(fileName) ==='string' ? fileName : fileName.name;
        return lFileName.length > 0 ? lFileName.replace(/\.[^/.]+$/, "") : lFileName;
    }

}
